import { useEffect } from 'react';
import storage from '../services/storage';
import { trackVisit } from '../lib/trackVisit';
import useCheckoutState from './useCheckoutState';

const useVisitTracking = () => {
  const { checkout, seller, setVisitId, isTesting } = useCheckoutState();

  useEffect(() => {
    if (isTesting) return;
    if (!checkout._id) return;

    async function track() {
      const response = await trackVisit({
        sellerId: seller._id,
        pageId: checkout._id,
        checkoutId: checkout._id,
        referrer: document.referrer,
        url: window.location.href,
        session: storage.session.getItem('CheckoutPage.sessionId'),
      });

      if (response.data) {
        setVisitId(response.data._id);
      }
    }

    track();
  }, [checkout._id, isTesting, seller._id, setVisitId]);
};

export default useVisitTracking;
